<template>
  <div class="flex flex-col gap-4 items-center text-center">
    <Img
      :name="existCards ? 'ld-greet' : 'ld-cry'"
      class="w-85px"
    />
    <div class="flex flex-col gap-2">
      <p class="text-19px">
        {{
          existCards
            ? _t('package.ai_complete_tip_1', { count: cardCount })
            : _t('package.ai_complete_tip_4')
        }}
      </p>
      <p class="text-17px text-[var(--text-color-secondary)]">
        {{
          existCards
            ? couldStudy
              ? _t('package.ai_complete_tip_2')
              : _t('package.ai_complete_tip_3', {
                  count: cardDeficit,
                })
            : _t('package.ai_complete_tip_5')
        }}
      </p>
    </div>
    <div class="flex flex-col gap-2 w-full">
      <template v-if="existCards">
        <template v-if="couldStudy">
          <Button
            :label="_t('package.ai_complete_button_1')"
            scene="primary"
            @click="emit('goToStudy'), emit('done')"
          ></Button>
          <Button
            :label="_t('package.ai_complete_button_2')"
            scene="secondary"
            @click="emit('done')"
          ></Button>
        </template>
        <Button
          v-else
          :label="_t('package.ai_complete_button_3')"
          @click="emit('done')"
        ></Button>
      </template>
      <Button
        v-else
        :label="_t('package.ai_complete_button_4')"
        @click="emit('done')"
      ></Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import Button from '@/components/Button.vue'
import { computed } from 'vue'

const props = defineProps<{
  /** 这次生成一共生成了多少卡片 */
  cardCount: number
  /** 还差多少卡片可以开始学习 */
  cardDeficit: number
}>()

const emit = defineEmits<{
  /** 去学习 */
  goToStudy: []
  /** 关闭弹窗 */
  done: []
}>()

const existCards = computed(() => props.cardCount > 0)
const couldStudy = computed(() => props.cardDeficit <= 0)
</script>
